import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchDistinctAdvisors() {
  try {
    const advisors = yield call(function() {
      return Api.get('/intervention-advisors')
    });
    yield put({type: 'FETCH_DISTINCT_ADVISORS.SUCCESS', advisors});
  } catch (error) {
    yield put({type: 'FETCH_DISTINCT_ADVISORS.FAILURE', error});
  }
}

export function* watchFetchDistinctAdvisors() {
  yield takeEvery('FETCH_DISTINCT_ADVISORS.REQUEST', fetchDistinctAdvisors)
}
